import styled from 'styled-components'

export const ContainerNotFound = styled.div`
    color: rgb(0,0,0,.85)
`
